import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { CostProduct } from './../../_models/financials/costProduct';

@Injectable()
export class CostProductsService {
  private apiBaseUrl = environment.financeServiceUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<CostProduct[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/finance/invoice/expenses')
      .pipe(map((response) => response));
  }

  get(id: number): Observable<CostProduct> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/finance/invoice/expenses/' + id)
      .pipe(map((response) => response));
  }

  save(costProductItem): Observable<CostProduct> {
    const costProduct = costProductItem;
    delete costProduct.lastUpdated;
    delete costProduct.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    costProduct.companyId = companySelected ? companySelected.id : null;

    if (costProduct.id) {
      return this.http
        .put<CostProduct>(
          this.apiBaseUrl + 'api/private/v1/finance/invoice/expenses/' + costProduct.id,
          costProduct
        )
        .pipe(
          catchError((error: any) => {
            return throwError(error);
          })
        );
    } else {
      return this.http
        .post<CostProduct>(
          this.apiBaseUrl + 'api/private/v1/finance/invoice/expenses/multi',
          costProduct
        )
        .pipe(
          catchError((error: any) => {
            return throwError(error);
          })
        );
    }
  }

  delete(costProduct: CostProduct): Observable<CostProduct> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/finance/invoice/expenses/' + costProduct.id)
      .pipe(
        map((response) => {
          return { id: costProduct.id } as CostProduct;
        })
      );
  }

  deleteProductDocs(costProduct: CostProduct): Observable<CostProduct> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/financial/costProductDocs/' + costProduct.id)
      .pipe(
        map((response) => {
          return { id: costProduct.id } as CostProduct;
        })
      );
  }
}
